export default {
  state: {
    filter: {},
    items: [],
  },
  getters: {},
  mutations: {
    APPLY_FILTER: (state: any, payload: any) => (state.filter = payload),
    SET_CMP_TYPES: (state: any, payload: any[]) => (state.items = payload),
  },
  actions: {
    applyFilter: (context: any, payload: any) => context.commit("APPLY_FILTER", payload),
    setCmpTypes: (context: any, payload: any[]) => context.commit("SET_CMP_TYPES", payload),
  },
};
